import React, { useState, useEffect } from "react"
import { useDataProvider } from "react-admin"
import { SelectInput } from "react-admin"
import { useController } from "react-hook-form"

interface Level {
    level_id: number
    parentId: string | null
    choices: Choice[]
    selected: string[]
}

interface Choice {
    id: string
    name: string
    varname: string
    parent_id?: string | null
}

interface props {
    readonly: boolean
    reference: string
    source: string
    label: string
}

function HierarchicalSelects(props: React.PropsWithChildren<props>): JSX.Element  {
    const { source, reference, label, readonly } = props
    const dataProvider = useDataProvider()
    const { field: { value: selectedVals } } = useController({ name: source })
    const [levels, setLevels] = useState<Level[]>([])

    const loadNextLevel = (parentId: string | null, levelIndex: number, preLevels: Level[]) => {
        dataProvider.getList<Choice>(reference, {
            filter: { parent_id: parentId },
            pagination: { page: 1, perPage: 100 },
            sort: { field: "name", order: "ASC" },
        })
        .then((response) => {
            const newLevels = preLevels.length > 0 ? preLevels : levels.slice(0, levelIndex + 1) // clear child level
            newLevels.push({
                level_id: levelIndex + 1,
                parentId,
                choices: response?.data || [],
                selected: [],
            })
            if (levelIndex <= (selectedVals?.length-1) ) {
                loadNextLevel(selectedVals[levelIndex],levelIndex+1, newLevels)
            } else {
                setLevels(newLevels)
            }
        })
        .catch((err) => {
            console.debug("Failed to load next level:", err)
        })
    }

    // Обработчик изменения выбора на уровне
    const handleSelectionChange = (selected: string, levelIndex: number) => {
        if (selected.length > 0) {
            loadNextLevel(selected, levelIndex+1, [])
        } else {
            setLevels(levels.slice(0, levelIndex + 1)) // clear child level
        }
    }

    // При загрузке компонента загружаем первый уровень
    useEffect(() => {
        loadNextLevel(null, 0, [])
    }, [selectedVals])

    return (
        <div>
            {levels.map((level, index) => (
                (level.choices.length > 0 &&
                <div key={level.level_id}>
                    <SelectInput
                        required
                        disabled={readonly}
                        label={label}
                        source={`${source}[${index}]`}
                        optionText="name"
                        choices={level.choices}
                        onChange={(event: any) => {
                            handleSelectionChange(event.target.value, index)
                        }}
                    />
                </div>)
            ))}
        </div>
    )
}

export default HierarchicalSelects
